import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { PageErrorState } from '@/components/feedback/PageErrorState';

export function ErrorPage(): JSX.Element {
  return (
    <AppShell hideTabs>
      <PageContainer>
        <PageErrorState error={new Error('Unexpected error')} />
      </PageContainer>
    </AppShell>
  );
}
